var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlareLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.999 12C23.999 18.6274 18.6264 24 11.999 24C5.37161 24 -0.000976562 18.6274 -0.000976562 12C-0.000976562 5.37258 5.37161 0 11.999 0C18.6264 0 23.999 5.37258 23.999 12Z",
    fill: "#CF2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9188 10.5687L8.99902 10.5632C7.38514 10.5632 6.04494 11.8606 5.99902 13.5277C5.99902 13.5742 6.03331 13.6085 6.07923 13.6085L11.999 13.614C13.6129 13.614 14.9531 12.3167 14.999 10.6551C14.9984 10.6036 14.9641 10.5687 14.9188 10.5687Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.919 6.00551L8.99925 6C7.38476 6 6.04456 7.29673 5.99925 8.96449C5.99925 9.01102 6.03354 9.04591 6.07885 9.04591L14.9986 9.05142C16.6125 9.05142 17.9527 7.75408 17.9986 6.09245C18.0041 6.04041 17.9643 6.00551 17.919 6.00551Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92547 15.2253C7.69077 14.9033 8.56812 15.2725 8.88526 16.0494C9.2024 16.8263 8.83873 17.7172 8.07342 18.0392C7.30812 18.3612 6.43077 17.9921 6.11363 17.2151C5.79649 16.4382 6.16016 15.5474 6.92547 15.2253Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlareLogo);
export default __webpack_public_path__ + "static/media/flare-logo.73176e4110b6dd365400c5fb56552b6d.svg";
export { ForwardRef as ReactComponent };